var citems = [];
var cids = [];
var compsmodule;

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const comps = document.querySelectorAll(".comp-product");
        comps.forEach((comp) => {
          var vid = comp.querySelector('[name="id"]').value;
          var qty = comp.querySelector('[name="quantity"]').value;
          if (qty > 0) {
            compsmodule = true;
            cids.push(vid);
            citems.push({ quantity: qty, id: vid });
          }
      });
      
      if(compsmodule != true){
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form); 
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);       
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => { 
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
          
        })
        .catch((e) => {console.log(e);
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
        }else{
          var mid = document.querySelector('.product-form-wrapper [name="id"]').value;
          var mqty = document.querySelector(
            '.product-form__input.product-form__quantity [name="quantity"]'
          ).value;
          citems.push({ quantity: mqty, id: mid });
          cids.push(mid);
          let formData = {
            items: citems,
            sections:
              "cart-notification-product,cart-notification-button,cart-icon-bubble",
          }; 
        
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                return;
              }              
              var cartNotification = document.querySelector("cart-notification");
              cartNotification.cartItemKey = "undefined";
              var productIds = cids;
              var productid;
              cartNotification.getSectionsToRender().forEach((section) => {
                if (
                  section.id == "cart-icon-bubble" ||
                  section.id == "cart-notification-button"
                ) {
                  document.getElementById(section.id).innerHTML =
                    response.sections[section.id];
                }
              });
              document.getElementById("cart-notification-product").innerHTML = "";
              productIds.forEach((productId) => {
                productid = JSON.stringify(productId);                
                cartNotification.getSectionsToRender().forEach((section) => {
                  if (
                    section.id != "cart-icon-bubble" &&
                    section.id != "cart-notification-button"
                  ) {
                    document.getElementById(section.id).innerHTML +=
                      '<div class="cart-notification-product">' +
                      cartNotification.getSectionInnerHTML(
                        response.sections[section.id],
                        `#cart-notification-product-${productId}`
                      ) +
                      "</div>";
                  }
                });
              });
              if (cartNotification.header) cartNotification.header.reveal();
              cartNotification.open();
              citems = [];
              cids = [];
            })
            .catch((e) => {
              console.log(e);
              console.error(e);
            })
            .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
        }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


if (document.getElementById("addcomp").length) {
document.getElementById("addcomp").addEventListener("click", (event) => {
  var mid = document.querySelector('.product-form-wrapper [name="id"]').value;
  var mqty = document.querySelector(
    '.product-form__input.product-form__quantity [name="quantity"]'
  ).value;
  const comps = document.querySelectorAll(".comp-product");
  comps.forEach((comp) => {
    var vid = comp.querySelector('[name="id"]').value;
    var qty = comp.querySelector('[name="quantity"]').value;
    if (qty > 0) {
      cids.push(vid);
      citems.push({ quantity: qty, id: vid });
    }
  });
  citems.push({ quantity: mqty, id: mid });
  cids.push(mid);
  
  let formData = {
    items: citems,
    sections:
      "cart-notification-product,cart-notification-button,cart-icon-bubble",
  }; 

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        return;
      }
      //cartNotification.renderiContents(response);
      //window.location.href = '/cart';
      var cartNotification = document.querySelector("cart-notification");
      cartNotification.cartItemKey = "undefined";
      var productIds = cids;
      var productid;
      cartNotification.getSectionsToRender().forEach((section) => {
        if (
          section.id == "cart-icon-bubble" ||
          section.id == "cart-notification-button"
        ) {
          document.getElementById(section.id).innerHTML =
            response.sections[section.id];
        }
      });
      document.getElementById("cart-notification-product").innerHTML = "";
      productIds.forEach((productId) => {
        productid = JSON.stringify(productId);
        //console.log(productid);
        cartNotification.getSectionsToRender().forEach((section) => {
          if (
            section.id != "cart-icon-bubble" &&
            section.id != "cart-notification-button"
          ) {
            document.getElementById(section.id).innerHTML +=
              '<div class="cart-notification-product">' +
              cartNotification.getSectionInnerHTML(
                response.sections[section.id],
                `#cart-notification-product-${productId}`
              ) +
              "</div>";
          }
        });
      });
      if (cartNotification.header) cartNotification.header.reveal();
      cartNotification.open();
      citems = [];
      cids = [];
    })
    .catch((e) => {
      console.log(e);
      console.error(e);
    })
    .finally(() => {});
});
}